import { A as Co, T as _t, a as wt, S as Ct, P as kt, b as St, c as $t, N as Pt, M as jt, J as Nt, F as It, d as Rt, D as Tt, e as zt } from "./textarea-EfguEWJi.js";
import { f as En, g as Ln, B as On, C as Dn, h as Fn, i as Wn, j as Bn, k as Gn, l as Hn, m as qn, n as Kn, o as Un, p as Jn, q as Zn, r as Qn, s as Xn, t as Yn, u as es, v as os, w as ts, x as rs, y as as } from "./textarea-EfguEWJi.js";
import { u as fe, a as ko, k as se, e as ho, j as d, g as qe, b as ce, r as Y, d as So, D as At, c as Mt, M as Vt, f as Et, h as z, i as I, U as Ue, B as $, l as B, m as G, n as Q, o as Lt, p as Ot, q as ee, s as V, t as Dt, v as Je, w as Ft, x as $o, y as Wt, z as $e } from "./UnstyledButton-ujNMaBde.js";
import { A as ss } from "./UnstyledButton-ujNMaBde.js";
import { useState as re, useRef as ne, useMemo as Po, useEffect as Re, useCallback as X, Children as Bt, cloneElement as Gt, createElement as Ke, forwardRef as jo, useContext as Ht, createContext as qt } from "react";
import { u as Kt, T as No } from "./Typography-B9vO6XbU.js";
import { a as ls } from "./Typography-B9vO6XbU.js";
import { T as Ut } from "./TextInput-BwSh6Vl7.js";
import { c as Io, C as Jt, T as Zt, P as Qt, M as Xt } from "./Table-DyNRNAuP.js";
import { a as ds } from "./Table-DyNRNAuP.js";
import { g as vo, a as ze, b as Ae, I as Ro, c as To, d as Yt, C as er } from "./Checkbox-Uem0EnXG.js";
import { S as ms } from "./Checkbox-Uem0EnXG.js";
import { u as ie, a as te, i as or, c as Ze, C as tr, T as zo, O as bo, b as rr, I as me, B as ar, A as nr } from "./Button-CMUmoC07.js";
import { P as hs } from "./Button-CMUmoC07.js";
import { N as sr } from "./Notification-Do-uNydJ.js";
import { p as ir } from "./px-NcrtpzG0.js";
import { u as Ao, L as lr, g as cr, a as dr } from "./CloseButton-Bp_UJ8Gq.js";
import { c as ge, u as Qe } from "./DirectionProvider-DtCDJ2BX.js";
import { A as Mo } from "./AccordionChevron-D-UrV_dq.js";
import { c as Pe } from "./clamp-CqQfNxSP.js";
import './index.css';function Te(e, o) {
  return (r) => {
    if (typeof r != "string" || r.trim().length === 0)
      throw new Error(o);
    return `${e}-${r}`;
  };
}
function ur(e = { timeout: 2e3 }) {
  const [o, r] = re(null), [t, n] = re(!1), [a, i] = re(null), s = (l) => {
    window.clearTimeout(a), i(window.setTimeout(() => n(!1), e.timeout)), n(l);
  };
  return { copy: (l) => {
    "clipboard" in navigator ? navigator.clipboard.writeText(l).then(() => s(!0)).catch((h) => r(h)) : r(new Error("useClipboard: navigator.clipboard is not supported"));
  }, reset: () => {
    n(!1), r(null), window.clearTimeout(a);
  }, error: o, copied: t };
}
const mr = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
};
function pr(e) {
  const o = ne(0), r = ne(null), [t, n] = re(mr), a = Po(
    () => typeof window < "u" ? new ResizeObserver((i) => {
      const s = i[0];
      s && (cancelAnimationFrame(o.current), o.current = requestAnimationFrame(() => {
        if (r.current) {
          const c = s.borderBoxSize?.[0] || s.contentBoxSize?.[0];
          if (c) {
            const u = c.inlineSize, l = c.blockSize;
            n({
              width: u,
              height: l,
              x: s.contentRect.x,
              y: s.contentRect.y,
              top: s.contentRect.top,
              left: s.contentRect.left,
              bottom: s.contentRect.bottom,
              right: s.contentRect.right
            });
          } else
            n(s.contentRect);
        }
      }));
    }) : null,
    []
  );
  return Re(() => (r.current && a?.observe(r.current, e), () => {
    a?.disconnect(), o.current && cancelAnimationFrame(o.current);
  }), [r.current]), [r, t];
}
function hr(e) {
  const [o, { width: r, height: t }] = pr(e);
  return { ref: o, width: r, height: t };
}
function fo(e, o) {
  return o.length === 0 ? e : o.reduce(
    (r, t) => Math.abs(t - e) < Math.abs(r - e) ? t : r
  );
}
function go(e) {
  return e === "auto" || e === "dark" || e === "light";
}
function vr({
  key: e = "mantine-color-scheme-value"
} = {}) {
  let o;
  return {
    get: (r) => {
      if (typeof window > "u")
        return r;
      try {
        const t = window.localStorage.getItem(e);
        return go(t) ? t : r;
      } catch {
        return r;
      }
    },
    set: (r) => {
      try {
        window.localStorage.setItem(e, r);
      } catch (t) {
        console.warn(
          "[@mantine/core] Local storage color scheme manager was unable to save color scheme.",
          t
        );
      }
    },
    subscribe: (r) => {
      o = (t) => {
        t.storageArea === window.localStorage && t.key === e && go(t.newValue) && r(t.newValue);
      }, window.addEventListener("storage", o);
    },
    unsubscribe: () => {
      window.removeEventListener("storage", o);
    },
    clear: () => {
      window.localStorage.removeItem(e);
    }
  };
}
function br() {
  const e = fe(), o = ko(), r = se(e.breakpoints).reduce((t, n) => {
    const a = e.breakpoints[n].includes("px"), i = ir(e.breakpoints[n]), s = a ? `${i - 0.1}px` : ho(i - 0.1), c = a ? `${i}px` : ho(i);
    return `${t}@media (max-width: ${s}) {.mantine-visible-from-${n} {display: none !important;}}@media (min-width: ${c}) {.mantine-hidden-from-${n} {display: none !important;}}`;
  }, "");
  return /* @__PURE__ */ d.jsx(
    "style",
    {
      "data-mantine-styles": "classes",
      nonce: o?.(),
      dangerouslySetInnerHTML: { __html: r }
    }
  );
}
function Fe(e) {
  return Object.entries(e).map(([o, r]) => `${o}: ${r};`).join("");
}
function Vo(e, o) {
  const r = o ? [o] : [":root", ":host"], t = Fe(e.variables), n = t ? `${r.join(", ")}{${t}}` : "", a = Fe(e.dark), i = Fe(e.light), s = (l) => r.map(
    (h) => h === ":host" ? `${h}([data-mantine-color-scheme="${l}"])` : `${h}[data-mantine-color-scheme="${l}"]`
  ).join(", "), c = a ? `${s("dark")}{${a}}` : "", u = i ? `${s("light")}{${i}}` : "";
  return `${n}

${c}

${u}`;
}
function je({
  theme: e,
  color: o,
  colorScheme: r,
  name: t = o,
  withColorValues: n = !0
}) {
  if (!e.colors[o])
    return {};
  if (r === "light") {
    const s = qe(e, "light"), c = {
      [`--mantine-color-${t}-text`]: `var(--mantine-color-${t}-filled)`,
      [`--mantine-color-${t}-filled`]: `var(--mantine-color-${t}-${s})`,
      [`--mantine-color-${t}-filled-hover`]: `var(--mantine-color-${t}-${s === 9 ? 8 : s + 1})`,
      [`--mantine-color-${t}-light`]: ce(e.colors[o][s], 0.1),
      [`--mantine-color-${t}-light-hover`]: ce(e.colors[o][s], 0.12),
      [`--mantine-color-${t}-light-color`]: `var(--mantine-color-${t}-${s})`,
      [`--mantine-color-${t}-outline`]: `var(--mantine-color-${t}-${s})`,
      [`--mantine-color-${t}-outline-hover`]: ce(e.colors[o][s], 0.05)
    };
    return n ? {
      [`--mantine-color-${t}-0`]: e.colors[o][0],
      [`--mantine-color-${t}-1`]: e.colors[o][1],
      [`--mantine-color-${t}-2`]: e.colors[o][2],
      [`--mantine-color-${t}-3`]: e.colors[o][3],
      [`--mantine-color-${t}-4`]: e.colors[o][4],
      [`--mantine-color-${t}-5`]: e.colors[o][5],
      [`--mantine-color-${t}-6`]: e.colors[o][6],
      [`--mantine-color-${t}-7`]: e.colors[o][7],
      [`--mantine-color-${t}-8`]: e.colors[o][8],
      [`--mantine-color-${t}-9`]: e.colors[o][9],
      ...c
    } : c;
  }
  const a = qe(e, "dark"), i = {
    [`--mantine-color-${t}-text`]: `var(--mantine-color-${t}-4)`,
    [`--mantine-color-${t}-filled`]: `var(--mantine-color-${t}-${a})`,
    [`--mantine-color-${t}-filled-hover`]: `var(--mantine-color-${t}-${a === 9 ? 8 : a + 1})`,
    [`--mantine-color-${t}-light`]: ce(
      e.colors[o][Math.max(0, a - 2)],
      0.15
    ),
    [`--mantine-color-${t}-light-hover`]: ce(
      e.colors[o][Math.max(0, a - 2)],
      0.2
    ),
    [`--mantine-color-${t}-light-color`]: `var(--mantine-color-${t}-${Math.max(a - 5, 0)})`,
    [`--mantine-color-${t}-outline`]: `var(--mantine-color-${t}-${Math.max(a - 4, 0)})`,
    [`--mantine-color-${t}-outline-hover`]: ce(
      e.colors[o][Math.max(a - 4, 0)],
      0.05
    )
  };
  return n ? {
    [`--mantine-color-${t}-0`]: e.colors[o][0],
    [`--mantine-color-${t}-1`]: e.colors[o][1],
    [`--mantine-color-${t}-2`]: e.colors[o][2],
    [`--mantine-color-${t}-3`]: e.colors[o][3],
    [`--mantine-color-${t}-4`]: e.colors[o][4],
    [`--mantine-color-${t}-5`]: e.colors[o][5],
    [`--mantine-color-${t}-6`]: e.colors[o][6],
    [`--mantine-color-${t}-7`]: e.colors[o][7],
    [`--mantine-color-${t}-8`]: e.colors[o][8],
    [`--mantine-color-${t}-9`]: e.colors[o][9],
    ...i
  } : i;
}
function fr(e) {
  return !!e && typeof e == "object" && "mantine-virtual-color" in e;
}
function de(e, o, r) {
  se(o).forEach(
    (t) => Object.assign(e, { [`--mantine-${r}-${t}`]: o[t] })
  );
}
const Eo = (e) => {
  const o = qe(e, "light"), r = e.defaultRadius in e.radius ? e.radius[e.defaultRadius] : Y(e.defaultRadius), t = {
    variables: {
      "--mantine-z-index-app": "100",
      "--mantine-z-index-modal": "200",
      "--mantine-z-index-popover": "300",
      "--mantine-z-index-overlay": "400",
      "--mantine-z-index-max": "9999",
      "--mantine-scale": e.scale.toString(),
      "--mantine-cursor-type": e.cursorType,
      "--mantine-webkit-font-smoothing": e.fontSmoothing ? "antialiased" : "unset",
      "--mantine-moz-font-smoothing": e.fontSmoothing ? "grayscale" : "unset",
      "--mantine-color-white": e.white,
      "--mantine-color-black": e.black,
      "--mantine-line-height": e.lineHeights.md,
      "--mantine-font-family": e.fontFamily,
      "--mantine-font-family-monospace": e.fontFamilyMonospace,
      "--mantine-font-family-headings": e.headings.fontFamily,
      "--mantine-heading-font-weight": e.headings.fontWeight,
      "--mantine-heading-text-wrap": e.headings.textWrap,
      "--mantine-radius-default": r,
      // Primary colors
      "--mantine-primary-color-filled": `var(--mantine-color-${e.primaryColor}-filled)`,
      "--mantine-primary-color-filled-hover": `var(--mantine-color-${e.primaryColor}-filled-hover)`,
      "--mantine-primary-color-light": `var(--mantine-color-${e.primaryColor}-light)`,
      "--mantine-primary-color-light-hover": `var(--mantine-color-${e.primaryColor}-light-hover)`,
      "--mantine-primary-color-light-color": `var(--mantine-color-${e.primaryColor}-light-color)`
    },
    light: {
      "--mantine-color-scheme": "light",
      "--mantine-primary-color-contrast": vo(e, "light"),
      "--mantine-color-bright": "var(--mantine-color-black)",
      "--mantine-color-text": e.black,
      "--mantine-color-body": e.white,
      "--mantine-color-error": "var(--mantine-color-red-6)",
      "--mantine-color-placeholder": "var(--mantine-color-gray-5)",
      "--mantine-color-anchor": `var(--mantine-color-${e.primaryColor}-${o})`,
      "--mantine-color-default": "var(--mantine-color-white)",
      "--mantine-color-default-hover": "var(--mantine-color-gray-0)",
      "--mantine-color-default-color": "var(--mantine-color-black)",
      "--mantine-color-default-border": "var(--mantine-color-gray-4)",
      "--mantine-color-dimmed": "var(--mantine-color-gray-6)",
      "--mantine-color-disabled": "var(--mantine-color-gray-2)",
      "--mantine-color-disabled-color": "var(--mantine-color-gray-5)",
      "--mantine-color-disabled-border": "var(--mantine-color-gray-3)"
    },
    dark: {
      "--mantine-color-scheme": "dark",
      "--mantine-primary-color-contrast": vo(e, "dark"),
      "--mantine-color-bright": "var(--mantine-color-white)",
      "--mantine-color-text": "var(--mantine-color-dark-0)",
      "--mantine-color-body": "var(--mantine-color-dark-7)",
      "--mantine-color-error": "var(--mantine-color-red-8)",
      "--mantine-color-placeholder": "var(--mantine-color-dark-3)",
      "--mantine-color-anchor": `var(--mantine-color-${e.primaryColor}-4)`,
      "--mantine-color-default": "var(--mantine-color-dark-6)",
      "--mantine-color-default-hover": "var(--mantine-color-dark-5)",
      "--mantine-color-default-color": "var(--mantine-color-white)",
      "--mantine-color-default-border": "var(--mantine-color-dark-4)",
      "--mantine-color-dimmed": "var(--mantine-color-dark-2)",
      "--mantine-color-disabled": "var(--mantine-color-dark-6)",
      "--mantine-color-disabled-color": "var(--mantine-color-dark-3)",
      "--mantine-color-disabled-border": "var(--mantine-color-dark-4)"
    }
  };
  de(t.variables, e.breakpoints, "breakpoint"), de(t.variables, e.spacing, "spacing"), de(t.variables, e.fontSizes, "font-size"), de(t.variables, e.lineHeights, "line-height"), de(t.variables, e.shadows, "shadow"), de(t.variables, e.radius, "radius"), e.colors[e.primaryColor].forEach((a, i) => {
    t.variables[`--mantine-primary-color-${i}`] = `var(--mantine-color-${e.primaryColor}-${i})`;
  }), se(e.colors).forEach((a) => {
    const i = e.colors[a];
    if (fr(i)) {
      Object.assign(
        t.light,
        je({
          theme: e,
          name: i.name,
          color: i.light,
          colorScheme: "light",
          withColorValues: !0
        })
      ), Object.assign(
        t.dark,
        je({
          theme: e,
          name: i.name,
          color: i.dark,
          colorScheme: "dark",
          withColorValues: !0
        })
      );
      return;
    }
    i.forEach((s, c) => {
      t.variables[`--mantine-color-${a}-${c}`] = s;
    }), Object.assign(
      t.light,
      je({
        theme: e,
        color: a,
        colorScheme: "light",
        withColorValues: !1
      })
    ), Object.assign(
      t.dark,
      je({
        theme: e,
        color: a,
        colorScheme: "dark",
        withColorValues: !1
      })
    );
  });
  const n = e.headings.sizes;
  return se(n).forEach((a) => {
    t.variables[`--mantine-${a}-font-size`] = n[a].fontSize, t.variables[`--mantine-${a}-line-height`] = n[a].lineHeight, t.variables[`--mantine-${a}-font-weight`] = n[a].fontWeight || e.headings.fontWeight;
  }), t;
};
function gr({ theme: e, generator: o }) {
  const r = Eo(e), t = o?.(e);
  return t ? So(r, t) : r;
}
const We = Eo(At);
function yr(e) {
  const o = {
    variables: {},
    light: {},
    dark: {}
  };
  return se(e.variables).forEach((r) => {
    We.variables[r] !== e.variables[r] && (o.variables[r] = e.variables[r]);
  }), se(e.light).forEach((r) => {
    We.light[r] !== e.light[r] && (o.light[r] = e.light[r]);
  }), se(e.dark).forEach((r) => {
    We.dark[r] !== e.dark[r] && (o.dark[r] = e.dark[r]);
  }), o;
}
function xr(e) {
  return Vo(
    {
      variables: {},
      dark: { "--mantine-color-scheme": "dark" },
      light: { "--mantine-color-scheme": "light" }
    },
    e
  );
}
function Lo({
  cssVariablesSelector: e,
  deduplicateCssVariables: o
}) {
  const r = fe(), t = ko(), n = Mt(), a = gr({ theme: r, generator: n }), i = (e === void 0 || e === ":root" || e === ":host") && o, s = i ? yr(a) : a, c = Vo(s, e);
  return c ? /* @__PURE__ */ d.jsx(
    "style",
    {
      "data-mantine-styles": !0,
      nonce: t?.(),
      dangerouslySetInnerHTML: {
        __html: `${c}${i ? "" : xr(e)}`
      }
    }
  ) : null;
}
Lo.displayName = "@mantine/CssVariables";
function ue(e, o) {
  const r = typeof window < "u" && "matchMedia" in window && window.matchMedia("(prefers-color-scheme: dark)")?.matches, t = e !== "auto" ? e : r ? "dark" : "light";
  o()?.setAttribute("data-mantine-color-scheme", t);
}
function _r({
  manager: e,
  defaultColorScheme: o,
  getRootElement: r,
  forceColorScheme: t
}) {
  const n = ne(null), [a, i] = re(() => e.get(o)), s = t || a, c = X(
    (l) => {
      t || (ue(l, r), i(l), e.set(l));
    },
    [e.set, s, t]
  ), u = X(() => {
    i(o), ue(o, r), e.clear();
  }, [e.clear, o]);
  return Re(() => (e.subscribe(c), e.unsubscribe), [e.subscribe, e.unsubscribe]), Ao(() => {
    ue(e.get(o), r);
  }, []), Re(() => {
    if (t)
      return ue(t, r), () => {
      };
    t === void 0 && ue(a, r), typeof window < "u" && "matchMedia" in window && (n.current = window.matchMedia("(prefers-color-scheme: dark)"));
    const l = (h) => {
      a === "auto" && ue(h.matches ? "dark" : "light", r);
    };
    return n.current?.addEventListener("change", l), () => n.current?.removeEventListener("change", l);
  }, [a, t]), { colorScheme: s, setColorScheme: c, clearColorScheme: u };
}
function wr({
  respectReducedMotion: e,
  getRootElement: o
}) {
  Ao(() => {
    e && o()?.setAttribute("data-respect-reduced-motion", "true");
  }, [e]);
}
function Oo({
  theme: e,
  children: o,
  getStyleNonce: r,
  withStaticClasses: t = !0,
  withGlobalClasses: n = !0,
  deduplicateCssVariables: a = !0,
  withCssVariables: i = !0,
  cssVariablesSelector: s,
  classNamesPrefix: c = "mantine",
  colorSchemeManager: u = vr(),
  defaultColorScheme: l = "light",
  getRootElement: h = () => document.documentElement,
  cssVariablesResolver: p,
  forceColorScheme: g,
  stylesTransform: b,
  env: f
}) {
  const { colorScheme: m, setColorScheme: y, clearColorScheme: x } = _r({
    defaultColorScheme: l,
    forceColorScheme: g,
    manager: u,
    getRootElement: h
  });
  return wr({
    respectReducedMotion: e?.respectReducedMotion || !1,
    getRootElement: h
  }), /* @__PURE__ */ d.jsx(
    Vt.Provider,
    {
      value: {
        colorScheme: m,
        setColorScheme: y,
        clearColorScheme: x,
        getRootElement: h,
        classNamesPrefix: c,
        getStyleNonce: r,
        cssVariablesResolver: p,
        cssVariablesSelector: s ?? ":root",
        withStaticClasses: t,
        stylesTransform: b,
        env: f
      },
      children: /* @__PURE__ */ d.jsxs(Et, { theme: e, children: [
        i && /* @__PURE__ */ d.jsx(
          Lo,
          {
            cssVariablesSelector: s,
            deduplicateCssVariables: a
          }
        ),
        n && /* @__PURE__ */ d.jsx(br, {}),
        o
      ] })
    }
  );
}
Oo.displayName = "@mantine/core/MantineProvider";
const Cr = ({
  defaultColorScheme: e,
  localStorageKey: o,
  forceColorScheme: r
}) => r ? `document.documentElement.setAttribute("data-mantine-color-scheme", '${r}');` : `try {
  var _colorScheme = window.localStorage.getItem("${o}");
  var colorScheme = _colorScheme === "light" || _colorScheme === "dark" || _colorScheme === "auto" ? _colorScheme : "${e}";
  var computedColorScheme = colorScheme !== "auto" ? colorScheme : window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  document.documentElement.setAttribute("data-mantine-color-scheme", computedColorScheme);
} catch (e) {}
`;
function Rn({
  defaultColorScheme: e = "light",
  localStorageKey: o = "mantine-color-scheme-value",
  forceColorScheme: r,
  ...t
}) {
  const n = ["light", "dark", "auto"].includes(e) ? e : "light";
  return /* @__PURE__ */ d.jsx(
    "script",
    {
      ...t,
      "data-mantine-script": !0,
      dangerouslySetInnerHTML: {
        __html: Cr({
          defaultColorScheme: n,
          localStorageKey: o,
          forceColorScheme: r
        })
      }
    }
  );
}
function kr(...e) {
  return e.reduce((o, r) => So(o, r), {});
}
const Tn = {
  suppressHydrationWarning: !0,
  "data-mantine-color-scheme": "light"
}, [Sr, Xe] = ge(
  "Accordion component was not found in the tree"
);
var ye = { root: "m_9bdbb667", panel: "m_df78851f", content: "m_4ba554d4", itemTitle: "m_8fa820a0", control: "m_4ba585b8", "control--default": "m_6939a5e9", "control--contained": "m_4271d21b", label: "m_df3ffa0f", chevron: "m_3f35ae96", icon: "m_9bd771fe", item: "m_9bd7b098", "item--default": "m_fe19b709", "item--contained": "m_1f921b3b", "item--filled": "m_2cdf939a", "item--separated": "m_9f59b069" };
const [$r, Do] = ge("Accordion.Item component was not found in the tree"), Ye = z((e, o) => {
  const {
    classNames: r,
    className: t,
    style: n,
    styles: a,
    vars: i,
    chevron: s,
    icon: c,
    onClick: u,
    onKeyDown: l,
    children: h,
    disabled: p,
    mod: g,
    ...b
  } = I("AccordionControl", null, e), { value: f } = Do(), m = Xe(), y = m.isItemActive(f), x = typeof m.order == "number", w = `h${m.order}`, _ = /* @__PURE__ */ d.jsxs(
    Ue,
    {
      ...b,
      ...m.getStyles("control", { className: t, classNames: r, style: n, styles: a, variant: m.variant }),
      unstyled: m.unstyled,
      mod: [
        "accordion-control",
        { active: y, "chevron-position": m.chevronPosition, disabled: p },
        g
      ],
      ref: o,
      onClick: (v) => {
        u?.(v), m.onChange(f);
      },
      type: "button",
      disabled: p,
      "aria-expanded": y,
      "aria-controls": m.getRegionId(f),
      id: m.getControlId(f),
      onKeyDown: Io({
        siblingSelector: "[data-accordion-control]",
        parentSelector: "[data-accordion]",
        activateOnFocus: !1,
        loop: m.loop,
        orientation: "vertical",
        onKeyDown: l
      }),
      children: [
        /* @__PURE__ */ d.jsx(
          $,
          {
            component: "span",
            mod: { rotate: !m.disableChevronRotation && y, position: m.chevronPosition },
            ...m.getStyles("chevron", { classNames: r, styles: a }),
            children: s || m.chevron
          }
        ),
        /* @__PURE__ */ d.jsx("span", { ...m.getStyles("label", { classNames: r, styles: a }), children: h }),
        c && /* @__PURE__ */ d.jsx(
          $,
          {
            component: "span",
            mod: { "chevron-position": m.chevronPosition },
            ...m.getStyles("icon", { classNames: r, styles: a }),
            children: c
          }
        )
      ]
    }
  );
  return x ? /* @__PURE__ */ d.jsx(w, { ...m.getStyles("itemTitle", { classNames: r, styles: a }), children: _ }) : _;
});
Ye.displayName = "@mantine/core/AccordionControl";
Ye.classes = ye;
const eo = z((e, o) => {
  const { classNames: r, className: t, style: n, styles: a, vars: i, value: s, mod: c, ...u } = I(
    "AccordionItem",
    null,
    e
  ), l = Xe();
  return /* @__PURE__ */ d.jsx($r, { value: { value: s }, children: /* @__PURE__ */ d.jsx(
    $,
    {
      ref: o,
      mod: [{ active: l.isItemActive(s) }, c],
      ...l.getStyles("item", { className: t, classNames: r, styles: a, style: n, variant: l.variant }),
      ...u
    }
  ) });
});
eo.displayName = "@mantine/core/AccordionItem";
eo.classes = ye;
const oo = z((e, o) => {
  const { classNames: r, className: t, style: n, styles: a, vars: i, children: s, ...c } = I(
    "AccordionPanel",
    null,
    e
  ), { value: u } = Do(), l = Xe();
  return /* @__PURE__ */ d.jsx(
    Jt,
    {
      ref: o,
      ...l.getStyles("panel", { className: t, classNames: r, style: n, styles: a }),
      ...c,
      in: l.isItemActive(u),
      transitionDuration: l.transitionDuration ?? 200,
      role: "region",
      id: l.getRegionId(u),
      "aria-labelledby": l.getControlId(u),
      children: /* @__PURE__ */ d.jsx("div", { ...l.getStyles("content", { classNames: r, styles: a }), children: s })
    }
  );
});
oo.displayName = "@mantine/core/AccordionPanel";
oo.classes = ye;
const Pr = {
  multiple: !1,
  disableChevronRotation: !1,
  chevronPosition: "right",
  variant: "default",
  chevronSize: "auto",
  chevronIconSize: 16
}, jr = G(
  (e, { transitionDuration: o, chevronSize: r, radius: t }) => ({
    root: {
      "--accordion-transition-duration": o === void 0 ? void 0 : `${o}ms`,
      "--accordion-chevron-size": r === void 0 ? void 0 : Y(r),
      "--accordion-radius": t === void 0 ? void 0 : Q(t)
    }
  })
);
function oe(e) {
  const o = I("Accordion", Pr, e), {
    classNames: r,
    className: t,
    style: n,
    styles: a,
    unstyled: i,
    vars: s,
    children: c,
    multiple: u,
    value: l,
    defaultValue: h,
    onChange: p,
    id: g,
    loop: b,
    transitionDuration: f,
    disableChevronRotation: m,
    chevronPosition: y,
    chevronSize: x,
    order: w,
    chevron: _,
    variant: v,
    radius: C,
    chevronIconSize: P,
    attributes: S,
    ...N
  } = o, R = ie(g), [k, j] = te({
    value: l,
    defaultValue: h,
    finalValue: u ? [] : null,
    onChange: p
  }), A = (L) => Array.isArray(k) ? k.includes(L) : L === k, U = (L) => {
    const O = Array.isArray(k) ? k.includes(L) ? k.filter((q) => q !== L) : [...k, L] : L === k ? null : L;
    j(O);
  }, T = B({
    name: "Accordion",
    classes: ye,
    props: o,
    className: t,
    style: n,
    classNames: r,
    styles: a,
    unstyled: i,
    attributes: S,
    vars: s,
    varsResolver: jr
  });
  return /* @__PURE__ */ d.jsx(
    Sr,
    {
      value: {
        isItemActive: A,
        onChange: U,
        getControlId: Te(
          `${R}-control`,
          "Accordion.Item component was rendered with invalid value or without value"
        ),
        getRegionId: Te(
          `${R}-panel`,
          "Accordion.Item component was rendered with invalid value or without value"
        ),
        chevron: _ === null ? null : _ || /* @__PURE__ */ d.jsx(Mo, { size: P }),
        transitionDuration: f,
        disableChevronRotation: m,
        chevronPosition: y,
        order: w,
        loop: b,
        getStyles: T,
        variant: v,
        unstyled: i
      },
      children: /* @__PURE__ */ d.jsx($, { ...T("root"), id: R, ...N, variant: v, "data-accordion": !0, children: c })
    }
  );
}
const Nr = (e) => e;
oe.extend = Nr;
oe.withProps = Lt(oe);
oe.classes = ye;
oe.displayName = "@mantine/core/Accordion";
oe.Item = eo;
oe.Panel = oo;
oe.Control = Ye;
oe.Chevron = Mo;
var Fo = { root: "m_347db0ec", "root--dot": "m_fbd81e3d", label: "m_5add502a", section: "m_91fdda9b" };
const Ir = G(
  (e, { radius: o, color: r, gradient: t, variant: n, size: a, autoContrast: i, circle: s }) => {
    const c = e.variantColorResolver({
      color: r || e.primaryColor,
      theme: e,
      gradient: t,
      variant: n || "filled",
      autoContrast: i
    });
    return {
      root: {
        "--badge-height": V(a, "badge-height"),
        "--badge-padding-x": V(a, "badge-padding-x"),
        "--badge-fz": V(a, "badge-fz"),
        "--badge-radius": s || o === void 0 ? void 0 : Q(o),
        "--badge-bg": r || n ? c.background : void 0,
        "--badge-color": r || n ? c.color : void 0,
        "--badge-bd": r || n ? c.border : void 0,
        "--badge-dot-color": n === "dot" ? ee(r, e) : void 0
      }
    };
  }
), Wo = Ot((e, o) => {
  const r = I("Badge", null, e), {
    classNames: t,
    className: n,
    style: a,
    styles: i,
    unstyled: s,
    vars: c,
    radius: u,
    color: l,
    gradient: h,
    leftSection: p,
    rightSection: g,
    children: b,
    variant: f,
    fullWidth: m,
    autoContrast: y,
    circle: x,
    mod: w,
    attributes: _,
    ...v
  } = r, C = B({
    name: "Badge",
    props: r,
    classes: Fo,
    className: n,
    style: a,
    classNames: t,
    styles: i,
    unstyled: s,
    attributes: _,
    vars: c,
    varsResolver: Ir
  });
  return /* @__PURE__ */ d.jsxs(
    $,
    {
      variant: f,
      mod: [
        {
          block: m,
          circle: x,
          "with-right-section": !!g,
          "with-left-section": !!p
        },
        w
      ],
      ...C("root", { variant: f }),
      ref: o,
      ...v,
      children: [
        p && /* @__PURE__ */ d.jsx("span", { ...C("section"), "data-position": "left", children: p }),
        /* @__PURE__ */ d.jsx("span", { ...C("label"), children: b }),
        g && /* @__PURE__ */ d.jsx("span", { ...C("section"), "data-position": "right", children: g })
      ]
    }
  );
});
Wo.classes = Fo;
Wo.displayName = "@mantine/core/Badge";
var Bo = { root: "m_8b3717df", breadcrumb: "m_f678d540", separator: "m_3b8f2208" };
const Rr = {
  separator: "/"
}, Tr = G((e, { separatorMargin: o }) => ({
  root: {
    "--bc-separator-margin": Dt(o)
  }
})), Go = z((e, o) => {
  const r = I("Breadcrumbs", Rr, e), {
    classNames: t,
    className: n,
    style: a,
    styles: i,
    unstyled: s,
    vars: c,
    children: u,
    separator: l,
    separatorMargin: h,
    attributes: p,
    ...g
  } = r, b = B({
    name: "Breadcrumbs",
    classes: Bo,
    props: r,
    className: n,
    style: a,
    classNames: t,
    styles: i,
    unstyled: s,
    attributes: p,
    vars: c,
    varsResolver: Tr
  }), f = Bt.toArray(u).reduce((m, y, x, w) => {
    const _ = or(y) ? Gt(y, {
      ...b("breadcrumb", { className: y.props?.className }),
      key: x
    }) : /* @__PURE__ */ Ke("div", { ...b("breadcrumb"), key: x }, y);
    return m.push(_), x !== w.length - 1 && m.push(
      /* @__PURE__ */ Ke($, { ...b("separator"), key: `separator-${x}` }, l)
    ), m;
  }, []);
  return /* @__PURE__ */ d.jsx($, { ref: o, ...b("root"), ...g, children: f });
});
Go.classes = Bo;
Go.displayName = "@mantine/core/Breadcrumbs";
var Ho = { root: "m_f59ffda3", label: "m_be049a53", "label--outline": "m_3904c1af", "label--filled": "m_fa109255", "label--light": "m_f7e165c3", iconWrapper: "m_9ac86df9", checkIcon: "m_d6d72580", input: "m_bde07329" };
const [zr, Ar] = Ze();
function qo(e) {
  const { value: o, defaultValue: r, onChange: t, multiple: n, children: a } = I("ChipGroup", null, e), [i, s] = te({
    value: o,
    defaultValue: r,
    finalValue: n ? [] : null,
    onChange: t
  }), c = (l) => Array.isArray(i) ? i.includes(l) : l === i, u = (l) => {
    const h = l.currentTarget.value;
    Array.isArray(i) ? s(i.includes(h) ? i.filter((p) => p !== h) : [...i, h]) : s(h);
  };
  return /* @__PURE__ */ d.jsx(zr, { value: { isChipSelected: c, onChange: u, multiple: n }, children: a });
}
qo.displayName = "@mantine/core/ChipGroup";
const Mr = {
  type: "checkbox"
}, Vr = G(
  (e, { size: o, radius: r, variant: t, color: n, autoContrast: a }) => {
    const i = e.variantColorResolver({
      color: n || e.primaryColor,
      theme: e,
      variant: t || "filled",
      autoContrast: a
    });
    return {
      root: {
        "--chip-fz": Ft(o),
        "--chip-size": V(o, "chip-size"),
        "--chip-radius": r === void 0 ? void 0 : Q(r),
        "--chip-checked-padding": V(o, "chip-checked-padding"),
        "--chip-padding": V(o, "chip-padding"),
        "--chip-icon-size": V(o, "chip-icon-size"),
        "--chip-bg": n || t ? i.background : void 0,
        "--chip-hover": n || t ? i.hover : void 0,
        "--chip-color": n || t ? i.color : void 0,
        "--chip-bd": n || t ? i.border : void 0,
        "--chip-spacing": V(o, "chip-spacing")
      }
    };
  }
), to = z((e, o) => {
  const r = I("Chip", Mr, e), {
    classNames: t,
    className: n,
    style: a,
    styles: i,
    unstyled: s,
    vars: c,
    id: u,
    checked: l,
    defaultChecked: h,
    onChange: p,
    value: g,
    wrapperProps: b,
    type: f,
    disabled: m,
    children: y,
    size: x,
    variant: w,
    icon: _,
    rootRef: v,
    autoContrast: C,
    mod: P,
    attributes: S,
    ...N
  } = r, R = B({
    name: "Chip",
    classes: Ho,
    props: r,
    className: n,
    style: a,
    classNames: t,
    styles: i,
    unstyled: s,
    attributes: S,
    vars: c,
    varsResolver: Vr
  }), k = Ar(), j = ie(u), { styleProps: A, rest: U } = Je(N), [T, L] = te({
    value: l,
    defaultValue: h,
    finalValue: !1,
    onChange: p
  }), O = k ? {
    checked: k.isChipSelected(g),
    onChange: (W) => {
      k.onChange(W), p?.(W.currentTarget.checked);
    },
    type: k.multiple ? "checkbox" : "radio"
  } : {}, q = O.checked || T;
  return /* @__PURE__ */ d.jsxs(
    $,
    {
      size: x,
      variant: w,
      ref: v,
      mod: P,
      ...R("root"),
      ...A,
      ...b,
      children: [
        /* @__PURE__ */ d.jsx(
          "input",
          {
            type: f,
            ...R("input"),
            checked: q,
            onChange: (W) => L(W.currentTarget.checked),
            id: j,
            disabled: m,
            ref: o,
            value: g,
            ...O,
            ...U
          }
        ),
        /* @__PURE__ */ d.jsxs(
          "label",
          {
            htmlFor: j,
            "data-checked": q || void 0,
            "data-disabled": m || void 0,
            ...R("label", { variant: w || "filled" }),
            children: [
              q && _ !== null && _ !== !1 && /* @__PURE__ */ d.jsx("span", { ...R("iconWrapper"), children: _ === void 0 ? /* @__PURE__ */ d.jsx(tr, { ...R("checkIcon") }) : _ }),
              /* @__PURE__ */ d.jsx("span", { children: y })
            ]
          }
        )
      ]
    }
  );
});
to.classes = Ho;
to.displayName = "@mantine/core/Chip";
to.Group = qo;
const Er = {
  timeout: 1e3
};
function Lr(e) {
  const { children: o, timeout: r, value: t, ...n } = I("CopyButton", Er, e), a = ur({ timeout: r }), i = () => a.copy(t);
  return /* @__PURE__ */ d.jsx(d.Fragment, { children: o({ copy: i, copied: a.copied, ...n }) });
}
Lr.displayName = "@mantine/core/CopyButton";
var Ko = { root: "m_6e45937b", loader: "m_e8eb006c", overlay: "m_df587f17" };
const yo = {
  transitionProps: { transition: "fade", duration: 0 },
  overlayProps: { backgroundOpacity: 0.75 },
  zIndex: cr("overlay")
}, Or = G((e, { zIndex: o }) => ({
  root: {
    "--lo-z-index": o?.toString()
  }
})), Uo = z((e, o) => {
  const r = I("LoadingOverlay", yo, e), {
    classNames: t,
    className: n,
    style: a,
    styles: i,
    unstyled: s,
    vars: c,
    transitionProps: u,
    loaderProps: l,
    overlayProps: h,
    visible: p,
    zIndex: g,
    attributes: b,
    ...f
  } = r, m = fe(), y = B({
    name: "LoadingOverlay",
    classes: Ko,
    props: r,
    className: n,
    style: a,
    classNames: t,
    styles: i,
    unstyled: s,
    attributes: b,
    vars: c,
    varsResolver: Or
  }), x = { ...yo.overlayProps, ...h };
  return /* @__PURE__ */ d.jsx(zo, { transition: "fade", ...u, mounted: !!p, children: (w) => /* @__PURE__ */ d.jsxs($, { ...y("root", { style: w }), ref: o, ...f, children: [
    /* @__PURE__ */ d.jsx(lr, { ...y("loader"), unstyled: s, ...l }),
    /* @__PURE__ */ d.jsx(
      bo,
      {
        ...x,
        ...y("overlay"),
        darkHidden: !0,
        unstyled: s,
        color: h?.color || m.white
      }
    ),
    /* @__PURE__ */ d.jsx(
      bo,
      {
        ...x,
        ...y("overlay"),
        lightHidden: !0,
        unstyled: s,
        color: h?.color || m.colors.dark[5]
      }
    )
  ] }) });
});
Uo.classes = Ko;
Uo.displayName = "@mantine/core/LoadingOverlay";
function Dr(e) {
  const o = e.reduce(
    (u, l) => ({ ...u, [l]: !1 }),
    {}
  ), [r, t] = re(o), n = X((u) => {
    t((l) => ({ ...l, [u]: !0 }));
  }, []), a = X(
    (u) => t((l) => ({ ...l, [u]: !1 })),
    []
  ), i = X(
    (u) => t((l) => ({ ...l, [u]: !l[u] })),
    []
  ), s = X(() => t(o), []), c = X(
    (u) => ({
      opened: r[u],
      onClose: () => a(u),
      stackId: u
    }),
    [r]
  );
  return { state: r, open: n, close: a, closeAll: s, toggle: i, register: c };
}
const zn = Dr;
var xe = { root: "m_db6d6462", section: "m_2242eb65", "stripes-animation": "m_81a374bd", "stripes-animation-vertical": "m_e0fb7a86", label: "m_91e40b74" };
const [Fr, Jo] = ge(
  "Progress.Root component was not found in tree"
), ro = z((e, o) => {
  const { classNames: r, className: t, style: n, styles: a, vars: i, ...s } = I(
    "ProgressLabel",
    null,
    e
  ), c = Jo();
  return /* @__PURE__ */ d.jsx(
    $,
    {
      ref: o,
      ...c.getStyles("label", { className: t, style: n, classNames: r, styles: a }),
      ...s
    }
  );
});
ro.classes = xe;
ro.displayName = "@mantine/core/ProgressLabel";
const Wr = G(
  (e, { size: o, radius: r, transitionDuration: t }) => ({
    root: {
      "--progress-size": V(o, "progress-size"),
      "--progress-radius": r === void 0 ? void 0 : Q(r),
      "--progress-transition-duration": typeof t == "number" ? `${t}ms` : void 0
    }
  })
), Me = z((e, o) => {
  const r = I("ProgressRoot", null, e), {
    classNames: t,
    className: n,
    style: a,
    styles: i,
    unstyled: s,
    vars: c,
    autoContrast: u,
    transitionDuration: l,
    orientation: h,
    attributes: p,
    mod: g,
    ...b
  } = r, f = B({
    name: "Progress",
    classes: xe,
    props: r,
    className: n,
    style: a,
    classNames: t,
    styles: i,
    unstyled: s,
    attributes: p,
    vars: c,
    varsResolver: Wr
  });
  return /* @__PURE__ */ d.jsx(Fr, { value: { getStyles: f, autoContrast: u }, children: /* @__PURE__ */ d.jsx($, { ref: o, mod: [{ orientation: h }, g], ...f("root"), ...b }) });
});
Me.classes = xe;
Me.displayName = "@mantine/core/ProgressRoot";
const Br = {
  withAria: !0
}, Ve = z((e, o) => {
  const {
    classNames: r,
    className: t,
    style: n,
    styles: a,
    vars: i,
    value: s,
    withAria: c,
    color: u,
    striped: l,
    animated: h,
    mod: p,
    ...g
  } = I("ProgressSection", Br, e), b = Jo(), f = fe(), m = c ? {
    role: "progressbar",
    "aria-valuemax": 100,
    "aria-valuemin": 0,
    "aria-valuenow": s,
    "aria-valuetext": `${s}%`
  } : {};
  return /* @__PURE__ */ d.jsx(
    $,
    {
      ref: o,
      ...b.getStyles("section", { className: t, classNames: r, styles: a, style: n }),
      ...g,
      ...m,
      mod: [{ striped: l || h, animated: h }, p],
      __vars: {
        "--progress-section-size": `${s}%`,
        "--progress-section-color": ee(u, f),
        "--progress-label-color": ze(b.autoContrast, f) ? Ae({ color: u, theme: f, autoContrast: b.autoContrast }) : void 0
      }
    }
  );
});
Ve.classes = xe;
Ve.displayName = "@mantine/core/ProgressSection";
const _e = z((e, o) => {
  const r = I("Progress", null, e), {
    value: t,
    classNames: n,
    styles: a,
    vars: i,
    color: s,
    striped: c,
    animated: u,
    "aria-label": l,
    ...h
  } = r, { resolvedClassNames: p, resolvedStyles: g } = rr({
    classNames: n,
    styles: a,
    props: r
  });
  return /* @__PURE__ */ d.jsx(
    Me,
    {
      ref: o,
      classNames: p,
      styles: g,
      vars: i,
      ...h,
      children: /* @__PURE__ */ d.jsx(
        Ve,
        {
          value: t,
          color: s,
          striped: c,
          animated: u,
          "aria-label": l
        }
      )
    }
  );
});
_e.classes = xe;
_e.displayName = "@mantine/core/Progress";
_e.Section = Ve;
_e.Root = Me;
_e.Label = ro;
var Zo = { root: "m_f3f1af94", inner: "m_89c4f5e4", icon: "m_f3ed6b2b", radio: "m_8a3dbb89", "radio--outline": "m_1bfe9d39" };
const [Gr, Qo] = Ze(), [Hr, qr] = Ze();
var Xo = { card: "m_9dc8ae12" };
const Kr = {
  withBorder: !0
}, Ur = G((e, { radius: o }) => ({
  card: {
    "--card-radius": Q(o)
  }
})), ao = z((e, o) => {
  const r = I("RadioCard", Kr, e), {
    classNames: t,
    className: n,
    style: a,
    styles: i,
    unstyled: s,
    vars: c,
    checked: u,
    mod: l,
    withBorder: h,
    value: p,
    onClick: g,
    name: b,
    onKeyDown: f,
    attributes: m,
    ...y
  } = r, x = B({
    name: "RadioCard",
    classes: Xo,
    props: r,
    className: n,
    style: a,
    classNames: t,
    styles: i,
    unstyled: s,
    attributes: m,
    vars: c,
    varsResolver: Ur,
    rootSelector: "card"
  }), { dir: w } = Qe(), _ = Qo(), v = typeof u == "boolean" ? u : _?.value === p || !1, C = b || _?.name, P = (S) => {
    if (f?.(S), ["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"].includes(S.nativeEvent.code)) {
      S.preventDefault();
      const N = Array.from(
        document.querySelectorAll(
          `[role="radio"][name="${C || "__mantine"}"]`
        )
      ), R = N.findIndex((A) => A === S.target), k = R + 1 >= N.length ? 0 : R + 1, j = R - 1 < 0 ? N.length - 1 : R - 1;
      S.nativeEvent.code === "ArrowDown" && (N[k].focus(), N[k].click()), S.nativeEvent.code === "ArrowUp" && (N[j].focus(), N[j].click()), S.nativeEvent.code === "ArrowLeft" && (N[w === "ltr" ? j : k].focus(), N[w === "ltr" ? j : k].click()), S.nativeEvent.code === "ArrowRight" && (N[w === "ltr" ? k : j].focus(), N[w === "ltr" ? k : j].click());
    }
  };
  return /* @__PURE__ */ d.jsx(Hr, { value: { checked: v }, children: /* @__PURE__ */ d.jsx(
    Ue,
    {
      ref: o,
      mod: [{ "with-border": h, checked: v }, l],
      ...x("card"),
      ...y,
      role: "radio",
      "aria-checked": v,
      name: C,
      onClick: (S) => {
        g?.(S), _?.onChange(p || "");
      },
      onKeyDown: P
    }
  ) });
});
ao.displayName = "@mantine/core/RadioCard";
ao.classes = Xo;
const no = z((e, o) => {
  const {
    value: r,
    defaultValue: t,
    onChange: n,
    size: a,
    wrapperProps: i,
    children: s,
    name: c,
    readOnly: u,
    disabled: l,
    ...h
  } = I("RadioGroup", null, e), p = ie(c), [g, b] = te({
    value: r,
    defaultValue: t,
    finalValue: "",
    onChange: n
  }), f = (m) => !u && b(typeof m == "string" ? m : m.currentTarget.value);
  return /* @__PURE__ */ d.jsx(
    Gr,
    {
      value: { value: g, onChange: f, size: a, name: p, disabled: l },
      children: /* @__PURE__ */ d.jsx(
        me.Wrapper,
        {
          size: a,
          ref: o,
          ...i,
          ...h,
          labelElement: "div",
          __staticSelector: "RadioGroup",
          children: /* @__PURE__ */ d.jsx(Ro, { role: "radiogroup", children: s })
        }
      )
    }
  );
});
no.classes = me.Wrapper.classes;
no.displayName = "@mantine/core/RadioGroup";
function Yo({ size: e, style: o, ...r }) {
  return /* @__PURE__ */ d.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 5 5",
      style: { width: Y(e), height: Y(e), ...o },
      "aria-hidden": !0,
      ...r,
      children: /* @__PURE__ */ d.jsx("circle", { cx: "2.5", cy: "2.5", r: "2.5", fill: "currentColor" })
    }
  );
}
var et = { indicator: "m_717d7ff6", icon: "m_3e4da632", "indicator--outline": "m_2980836c" };
const Jr = {
  icon: Yo
}, Zr = G(
  (e, { radius: o, color: r, size: t, iconColor: n, variant: a, autoContrast: i }) => {
    const s = $o({ color: r || e.primaryColor, theme: e }), c = s.isThemeColor && s.shade === void 0 ? `var(--mantine-color-${s.color}-outline)` : s.color;
    return {
      indicator: {
        "--radio-size": V(t, "radio-size"),
        "--radio-radius": o === void 0 ? void 0 : Q(o),
        "--radio-color": a === "outline" ? c : ee(r, e),
        "--radio-icon-size": V(t, "radio-icon-size"),
        "--radio-icon-color": n ? ee(n, e) : ze(i, e) ? Ae({ color: r, theme: e, autoContrast: i }) : void 0
      }
    };
  }
), Ee = z((e, o) => {
  const r = I("RadioIndicator", Jr, e), {
    classNames: t,
    className: n,
    style: a,
    styles: i,
    unstyled: s,
    vars: c,
    icon: u,
    radius: l,
    color: h,
    iconColor: p,
    autoContrast: g,
    checked: b,
    mod: f,
    variant: m,
    disabled: y,
    attributes: x,
    ...w
  } = r, _ = B({
    name: "RadioIndicator",
    classes: et,
    props: r,
    className: n,
    style: a,
    classNames: t,
    styles: i,
    unstyled: s,
    attributes: x,
    vars: c,
    varsResolver: Zr,
    rootSelector: "indicator"
  }), v = qr(), C = typeof b == "boolean" ? b : v?.checked || !1;
  return /* @__PURE__ */ d.jsx(
    $,
    {
      ref: o,
      ..._("indicator", { variant: m }),
      variant: m,
      mod: [{ checked: C, disabled: y }, f],
      ...w,
      children: /* @__PURE__ */ d.jsx(u, { ..._("icon") })
    }
  );
});
Ee.displayName = "@mantine/core/RadioIndicator";
Ee.classes = et;
const Qr = {
  labelPosition: "right"
}, Xr = G(
  (e, { size: o, radius: r, color: t, iconColor: n, variant: a, autoContrast: i }) => {
    const s = $o({ color: t || e.primaryColor, theme: e }), c = s.isThemeColor && s.shade === void 0 ? `var(--mantine-color-${s.color}-outline)` : s.color;
    return {
      root: {
        "--radio-size": V(o, "radio-size"),
        "--radio-radius": r === void 0 ? void 0 : Q(r),
        "--radio-color": a === "outline" ? c : ee(t, e),
        "--radio-icon-color": n ? ee(n, e) : ze(i, e) ? Ae({ color: t, theme: e, autoContrast: i }) : void 0,
        "--radio-icon-size": V(o, "radio-icon-size")
      }
    };
  }
), we = z((e, o) => {
  const r = I("Radio", Qr, e), {
    classNames: t,
    className: n,
    style: a,
    styles: i,
    unstyled: s,
    vars: c,
    id: u,
    size: l,
    label: h,
    labelPosition: p,
    description: g,
    error: b,
    radius: f,
    color: m,
    variant: y,
    disabled: x,
    wrapperProps: w,
    icon: _ = Yo,
    rootRef: v,
    iconColor: C,
    onChange: P,
    mod: S,
    attributes: N,
    checked: R,
    ...k
  } = r, j = B({
    name: "Radio",
    classes: Zo,
    props: r,
    className: n,
    style: a,
    classNames: t,
    styles: i,
    unstyled: s,
    attributes: N,
    vars: c,
    varsResolver: Xr
  }), A = Qo(), U = A?.size ?? l, T = r.size ? l : U, { styleProps: L, rest: O } = Je(k), q = ie(u), W = A ? A.value === O.value : void 0, J = {
    checked: W ?? R,
    name: A?.name ?? O.name,
    onChange: (Z) => {
      A?.onChange(Z), P?.(Z);
    },
    disabled: A?.disabled ?? x
  };
  return /* @__PURE__ */ d.jsx(
    To,
    {
      ...j("root"),
      __staticSelector: "Radio",
      __stylesApiProps: r,
      id: q,
      size: T,
      labelPosition: p,
      label: h,
      description: g,
      error: b,
      disabled: J.disabled,
      classNames: t,
      styles: i,
      unstyled: s,
      "data-checked": (W ?? R) || void 0,
      variant: y,
      ref: v,
      mod: S,
      ...L,
      ...w,
      children: /* @__PURE__ */ d.jsxs($, { ...j("inner"), mod: { "label-position": p }, children: [
        /* @__PURE__ */ d.jsx(
          $,
          {
            ...j("radio", { focusable: !0, variant: y }),
            ...O,
            ...J,
            component: "input",
            mod: { error: !!b },
            ref: o,
            id: q,
            type: "radio"
          }
        ),
        /* @__PURE__ */ d.jsx(_, { ...j("icon"), "aria-hidden": !0 })
      ] })
    }
  );
});
we.classes = Zo;
we.displayName = "@mantine/core/Radio";
we.Group = no;
we.Card = ao;
we.Indicator = Ee;
var ot = { root: "m_18320242", "skeleton-fade": "m_299c329c" };
const Yr = {
  visible: !0,
  animate: !0
}, ea = G(
  (e, { width: o, height: r, radius: t, circle: n }) => ({
    root: {
      "--skeleton-height": Y(r),
      "--skeleton-width": n ? Y(r) : Y(o),
      "--skeleton-radius": n ? "1000px" : t === void 0 ? void 0 : Q(t)
    }
  })
), tt = z((e, o) => {
  const r = I("Skeleton", Yr, e), {
    classNames: t,
    className: n,
    style: a,
    styles: i,
    unstyled: s,
    vars: c,
    width: u,
    height: l,
    circle: h,
    visible: p,
    radius: g,
    animate: b,
    mod: f,
    attributes: m,
    ...y
  } = r, x = B({
    name: "Skeleton",
    classes: ot,
    props: r,
    className: n,
    style: a,
    classNames: t,
    styles: i,
    unstyled: s,
    attributes: m,
    vars: c,
    varsResolver: ea
  });
  return /* @__PURE__ */ d.jsx($, { ref: o, ...x("root"), mod: [{ visible: p, animate: b }, f], ...y });
});
tt.classes = ot;
tt.displayName = "@mantine/core/Skeleton";
const [oa, Le] = ge(
  "SliderProvider was not found in tree"
);
var rt = { root: "m_dd36362e", label: "m_c9357328", thumb: "m_c9a9a60a", trackContainer: "m_a8645c2", track: "m_c9ade57f", bar: "m_38aeed47", markWrapper: "m_b7b0423a", mark: "m_dd33bc19", markLabel: "m_68c77a5b" };
const at = jo(
  ({ size: e, disabled: o, variant: r, color: t, thumbSize: n, radius: a, ...i }, s) => {
    const { getStyles: c } = Le();
    return /* @__PURE__ */ d.jsx(
      $,
      {
        tabIndex: -1,
        variant: r,
        size: e,
        ref: s,
        ...c("root"),
        ...i
      }
    );
  }
);
at.displayName = "@mantine/core/SliderRoot";
const nt = jo(
  ({
    max: e,
    min: o,
    value: r,
    position: t,
    label: n,
    dragging: a,
    onMouseDown: i,
    onKeyDownCapture: s,
    labelTransitionProps: c,
    labelAlwaysOn: u,
    thumbLabel: l,
    onFocus: h,
    onBlur: p,
    showLabelOnHover: g,
    isHovered: b,
    children: f = null,
    disabled: m
  }, y) => {
    const { getStyles: x } = Le(), [w, _] = re(!1), v = u || a || w || g && b;
    return /* @__PURE__ */ d.jsxs(
      $,
      {
        tabIndex: 0,
        role: "slider",
        "aria-label": l,
        "aria-valuemax": e,
        "aria-valuemin": o,
        "aria-valuenow": r,
        ref: y,
        __vars: { "--slider-thumb-offset": `${t}%` },
        ...x("thumb", { focusable: !0 }),
        mod: { dragging: a, disabled: m },
        onFocus: (C) => {
          _(!0), typeof h == "function" && h(C);
        },
        onBlur: (C) => {
          _(!1), typeof p == "function" && p(C);
        },
        onTouchStart: i,
        onMouseDown: i,
        onKeyDownCapture: s,
        onClick: (C) => C.stopPropagation(),
        children: [
          f,
          /* @__PURE__ */ d.jsx(
            zo,
            {
              mounted: n != null && !!v,
              transition: "fade",
              duration: 0,
              ...c,
              children: (C) => /* @__PURE__ */ d.jsx("div", { ...x("label", { style: C }), children: n })
            }
          )
        ]
      }
    );
  }
);
nt.displayName = "@mantine/core/SliderThumb";
function st({ value: e, min: o, max: r }) {
  const t = (e - o) / (r - o) * 100;
  return Math.min(Math.max(t, 0), 100);
}
function ta({ mark: e, offset: o, value: r, inverted: t = !1 }) {
  return t ? typeof o == "number" && e.value <= o || e.value >= r : typeof o == "number" ? e.value >= o && e.value <= r : e.value <= r;
}
function it({ marks: e, min: o, max: r, disabled: t, value: n, offset: a, inverted: i }) {
  const { getStyles: s } = Le();
  if (!e)
    return null;
  const c = e.map((u, l) => /* @__PURE__ */ Ke(
    $,
    {
      ...s("markWrapper"),
      __vars: { "--mark-offset": `${st({ value: u.value, min: o, max: r })}%` },
      key: l
    },
    /* @__PURE__ */ d.jsx(
      $,
      {
        ...s("mark"),
        mod: { filled: ta({ mark: u, value: n, offset: a, inverted: i }), disabled: t }
      }
    ),
    u.label && /* @__PURE__ */ d.jsx("div", { ...s("markLabel"), children: u.label })
  ));
  return /* @__PURE__ */ d.jsx("div", { children: c });
}
it.displayName = "@mantine/core/SliderMarks";
function lt({
  filled: e,
  children: o,
  offset: r,
  disabled: t,
  marksOffset: n,
  inverted: a,
  containerProps: i,
  ...s
}) {
  const { getStyles: c } = Le();
  return /* @__PURE__ */ d.jsx($, { ...c("trackContainer"), mod: { disabled: t }, ...i, children: /* @__PURE__ */ d.jsxs($, { ...c("track"), mod: { inverted: a, disabled: t }, children: [
    /* @__PURE__ */ d.jsx(
      $,
      {
        mod: { inverted: a, disabled: t },
        __vars: {
          "--slider-bar-width": `calc(${e}% + 2 * var(--slider-size))`,
          "--slider-bar-offset": `calc(${r}% - var(--slider-size))`
        },
        ...c("bar")
      }
    ),
    o,
    /* @__PURE__ */ d.jsx(it, { ...s, offset: n, disabled: t, inverted: a })
  ] }) });
}
lt.displayName = "@mantine/core/SliderTrack";
function ra({
  value: e,
  containerWidth: o,
  min: r,
  max: t,
  step: n,
  precision: a
}) {
  const s = (o ? Math.min(Math.max(e, 0), o) / o : e) * (t - r), c = (s !== 0 ? Math.round(s / n) * n : 0) + r, u = Math.max(c, r);
  return a !== void 0 ? Number(u.toFixed(a)) : u;
}
function Ne(e, o) {
  return parseFloat(e.toFixed(o));
}
function aa(e) {
  if (!e)
    return 0;
  const o = e.toString().split(".");
  return o.length > 1 ? o[1].length : 0;
}
function Be(e, o) {
  const t = [...o].sort((n, a) => n.value - a.value).find((n) => n.value > e);
  return t ? t.value : e;
}
function Ge(e, o) {
  const t = [...o].sort((n, a) => a.value - n.value).find((n) => n.value < e);
  return t ? t.value : e;
}
function xo(e) {
  const o = [...e].sort((r, t) => r.value - t.value);
  return o.length > 0 ? o[0].value : 0;
}
function _o(e) {
  const o = [...e].sort((r, t) => r.value - t.value);
  return o.length > 0 ? o[o.length - 1].value : 100;
}
const na = {
  radius: "xl",
  min: 0,
  max: 100,
  step: 1,
  marks: [],
  label: (e) => e,
  labelTransitionProps: { transition: "fade", duration: 0 },
  thumbLabel: "",
  showLabelOnHover: !0,
  scale: (e) => e,
  size: "md"
}, sa = G(
  (e, { size: o, color: r, thumbSize: t, radius: n }) => ({
    root: {
      "--slider-size": V(o, "slider-size"),
      "--slider-color": r ? ee(r, e) : void 0,
      "--slider-radius": n === void 0 ? void 0 : Q(n),
      "--slider-thumb-size": t !== void 0 ? Y(t) : "calc(var(--slider-size) * 2)"
    }
  })
), ct = z((e, o) => {
  const r = I("Slider", na, e), {
    classNames: t,
    styles: n,
    value: a,
    onChange: i,
    onChangeEnd: s,
    size: c,
    min: u,
    max: l,
    domain: h,
    step: p,
    precision: g,
    defaultValue: b,
    name: f,
    marks: m,
    label: y,
    labelTransitionProps: x,
    labelAlwaysOn: w,
    thumbLabel: _,
    showLabelOnHover: v,
    thumbChildren: C,
    disabled: P,
    unstyled: S,
    scale: N,
    inverted: R,
    className: k,
    style: j,
    vars: A,
    hiddenInputProps: U,
    restrictToMarks: T,
    thumbProps: L,
    attributes: O,
    ...q
  } = r, W = B({
    name: "Slider",
    props: r,
    classes: rt,
    classNames: t,
    className: k,
    styles: n,
    style: j,
    attributes: O,
    vars: A,
    varsResolver: sa,
    unstyled: S
  }), { dir: J } = Qe(), [Z, pe] = re(!1), [E, M] = te({
    value: typeof a == "number" ? Pe(a, u, l) : a,
    defaultValue: typeof b == "number" ? Pe(b, u, l) : b,
    finalValue: Pe(0, u, l),
    onChange: i
  }), De = ne(E), he = ne(s);
  Re(() => {
    he.current = s;
  }, [s]);
  const mo = ne(null), ae = ne(null), [ve, be] = h || [u, l], po = st({ value: E, min: ve, max: be }), Se = N(E), ht = typeof y == "function" ? y(Se) : y, le = g ?? aa(p), vt = X(
    ({ x: H }) => {
      if (!P) {
        const D = ra({
          value: H,
          min: ve,
          max: be,
          step: p,
          precision: le
        }), F = Pe(D, u, l);
        M(
          T && m?.length ? fo(
            F,
            m.map((xt) => xt.value)
          ) : F
        ), De.current = F;
      }
    },
    [P, u, l, ve, be, p, le, M, m, T]
  ), bt = X(() => {
    if (!P && he.current) {
      const H = T && m?.length ? fo(
        De.current,
        m.map((D) => D.value)
      ) : De.current;
      he.current(H);
    }
  }, [P, m, T]), { ref: ft, active: gt } = Kt(vt, { onScrubEnd: bt }, J), K = X(
    (H) => {
      !P && he.current && he.current(H);
    },
    [P]
  ), yt = (H) => {
    if (!P)
      switch (H.key) {
        case "ArrowUp": {
          if (H.preventDefault(), ae.current?.focus(), T && m) {
            const F = Be(E, m);
            M(F), K(F);
            break;
          }
          const D = Ne(
            Math.min(Math.max(E + p, u), l),
            le
          );
          M(D), K(D);
          break;
        }
        case "ArrowRight": {
          if (H.preventDefault(), ae.current?.focus(), T && m) {
            const F = J === "rtl" ? Ge(E, m) : Be(E, m);
            M(F), K(F);
            break;
          }
          const D = Ne(
            Math.min(Math.max(J === "rtl" ? E - p : E + p, u), l),
            le
          );
          M(D), K(D);
          break;
        }
        case "ArrowDown": {
          if (H.preventDefault(), ae.current?.focus(), T && m) {
            const F = Ge(E, m);
            M(F), K(F);
            break;
          }
          const D = Ne(
            Math.min(Math.max(E - p, u), l),
            le
          );
          M(D), K(D);
          break;
        }
        case "ArrowLeft": {
          if (H.preventDefault(), ae.current?.focus(), T && m) {
            const F = J === "rtl" ? Be(E, m) : Ge(E, m);
            M(F), K(F);
            break;
          }
          const D = Ne(
            Math.min(Math.max(J === "rtl" ? E + p : E - p, u), l),
            le
          );
          M(D), K(D);
          break;
        }
        case "Home": {
          if (H.preventDefault(), ae.current?.focus(), T && m) {
            M(xo(m)), K(xo(m));
            break;
          }
          M(u), K(u);
          break;
        }
        case "End": {
          if (H.preventDefault(), ae.current?.focus(), T && m) {
            M(_o(m)), K(_o(m));
            break;
          }
          M(l), K(l);
          break;
        }
      }
  };
  return /* @__PURE__ */ d.jsx(oa, { value: { getStyles: W }, children: /* @__PURE__ */ d.jsxs(
    at,
    {
      ...q,
      ref: dr(o, mo),
      onKeyDownCapture: yt,
      onMouseDownCapture: () => mo.current?.focus(),
      size: c,
      disabled: P,
      children: [
        /* @__PURE__ */ d.jsx(
          lt,
          {
            inverted: R,
            offset: 0,
            filled: po,
            marks: m,
            min: ve,
            max: be,
            value: Se,
            disabled: P,
            containerProps: {
              ref: ft,
              onMouseEnter: v ? () => pe(!0) : void 0,
              onMouseLeave: v ? () => pe(!1) : void 0
            },
            children: /* @__PURE__ */ d.jsx(
              nt,
              {
                max: be,
                min: ve,
                value: Se,
                position: po,
                dragging: gt,
                label: ht,
                ref: ae,
                labelTransitionProps: x,
                labelAlwaysOn: w,
                thumbLabel: _,
                showLabelOnHover: v,
                isHovered: Z,
                disabled: P,
                ...L,
                children: C
              }
            )
          }
        ),
        /* @__PURE__ */ d.jsx("input", { type: "hidden", name: f, value: Se, ...U })
      ]
    }
  ) });
});
ct.classes = rt;
ct.displayName = "@mantine/core/Slider";
var dt = { root: "m_559cce2d", content: "m_b912df4e", control: "m_b9131032" };
const ia = {
  maxHeight: 100,
  initialState: !1
}, la = G((e, { transitionDuration: o }) => ({
  root: {
    "--spoiler-transition-duration": o !== void 0 ? `${o}ms` : void 0
  }
})), ut = z((e, o) => {
  const r = I("Spoiler", ia, e), {
    classNames: t,
    className: n,
    style: a,
    styles: i,
    unstyled: s,
    vars: c,
    initialState: u,
    maxHeight: l,
    hideLabel: h,
    showLabel: p,
    children: g,
    controlRef: b,
    transitionDuration: f,
    id: m,
    expanded: y,
    onExpandedChange: x,
    attributes: w,
    ..._
  } = r, v = B({
    name: "Spoiler",
    classes: dt,
    props: r,
    className: n,
    style: a,
    classNames: t,
    styles: i,
    unstyled: s,
    attributes: w,
    vars: c,
    varsResolver: la
  }), C = ie(m), P = `${C}-region`, [S, N] = te({
    value: y,
    defaultValue: u,
    finalValue: !1,
    onChange: x
  }), { ref: R, height: k } = hr(), j = S ? h : p, A = j !== null && l < k;
  return /* @__PURE__ */ d.jsxs(
    $,
    {
      ...v("root"),
      id: C,
      ref: o,
      "data-has-spoiler": A || void 0,
      ..._,
      children: [
        A && /* @__PURE__ */ d.jsx(
          Co,
          {
            component: "button",
            type: "button",
            ref: b,
            onClick: () => N(!S),
            "aria-expanded": S,
            "aria-controls": P,
            ...v("control"),
            children: j
          }
        ),
        /* @__PURE__ */ d.jsx(
          "div",
          {
            ...v("content", {
              style: { maxHeight: S ? k ? Y(k) : void 0 : Y(l) }
            }),
            "data-reduce-motion": !0,
            role: "region",
            id: P,
            children: /* @__PURE__ */ d.jsx("div", { ref: R, children: g })
          }
        )
      ]
    }
  );
});
ut.classes = dt;
ut.displayName = "@mantine/core/Spoiler";
var mt = { root: "m_5f93f3bb", input: "m_926b4011", track: "m_9307d992", thumb: "m_93039a1d", trackLabel: "m_8277e082" };
const pt = qt(null), ca = pt.Provider, da = () => Ht(pt), so = z((e, o) => {
  const {
    value: r,
    defaultValue: t,
    onChange: n,
    size: a,
    wrapperProps: i,
    children: s,
    readOnly: c,
    disabled: u,
    ...l
  } = I("SwitchGroup", null, e), [h, p] = te({
    value: r,
    defaultValue: t,
    finalValue: [],
    onChange: n
  }), g = (b) => {
    const f = b.currentTarget.value;
    !c && p(
      h.includes(f) ? h.filter((m) => m !== f) : [...h, f]
    );
  };
  return /* @__PURE__ */ d.jsx(ca, { value: { value: h, onChange: g, size: a, disabled: u }, children: /* @__PURE__ */ d.jsx(
    me.Wrapper,
    {
      size: a,
      ref: o,
      ...i,
      ...l,
      labelElement: "div",
      __staticSelector: "SwitchGroup",
      children: /* @__PURE__ */ d.jsx(Ro, { role: "group", children: s })
    }
  ) });
});
so.classes = me.Wrapper.classes;
so.displayName = "@mantine/core/SwitchGroup";
const ua = {
  labelPosition: "right",
  withThumbIndicator: !0
}, ma = G((e, { radius: o, color: r, size: t }) => ({
  root: {
    "--switch-radius": o === void 0 ? void 0 : Q(o),
    "--switch-height": V(t, "switch-height"),
    "--switch-width": V(t, "switch-width"),
    "--switch-thumb-size": V(t, "switch-thumb-size"),
    "--switch-label-font-size": V(t, "switch-label-font-size"),
    "--switch-track-label-padding": V(t, "switch-track-label-padding"),
    "--switch-color": r ? ee(r, e) : void 0
  }
})), Oe = z((e, o) => {
  const r = I("Switch", ua, e), {
    classNames: t,
    className: n,
    style: a,
    styles: i,
    unstyled: s,
    vars: c,
    color: u,
    label: l,
    offLabel: h,
    onLabel: p,
    id: g,
    size: b,
    radius: f,
    wrapperProps: m,
    thumbIcon: y,
    checked: x,
    defaultChecked: w,
    onChange: _,
    labelPosition: v,
    description: C,
    error: P,
    disabled: S,
    variant: N,
    rootRef: R,
    mod: k,
    withThumbIndicator: j,
    attributes: A,
    ...U
  } = r, T = da(), L = b || T?.size, O = B({
    name: "Switch",
    props: r,
    classes: mt,
    className: n,
    style: a,
    classNames: t,
    styles: i,
    unstyled: s,
    attributes: A,
    vars: c,
    varsResolver: ma
  }), { styleProps: q, rest: W } = Je(U), J = ie(g), Z = {
    checked: T?.value.includes(W.value) ?? x,
    onChange: (M) => {
      T?.onChange(M), _?.(M);
    },
    disabled: T?.disabled ?? S
  }, [pe, E] = te({
    value: Z.checked ?? x,
    defaultValue: w,
    finalValue: !1
  });
  return /* @__PURE__ */ d.jsxs(
    To,
    {
      ...O("root"),
      __staticSelector: "Switch",
      __stylesApiProps: r,
      id: J,
      size: L,
      labelPosition: v,
      label: l,
      description: C,
      error: P,
      disabled: Z.disabled,
      bodyElement: "label",
      labelElement: "span",
      classNames: t,
      styles: i,
      unstyled: s,
      "data-checked": Z.checked,
      variant: N,
      ref: R,
      mod: k,
      inert: W.inert,
      ...q,
      ...m,
      children: [
        /* @__PURE__ */ d.jsx(
          "input",
          {
            ...W,
            ...Z,
            checked: pe,
            "data-checked": Z.checked,
            onChange: (M) => {
              Z.onChange?.(M), E(M.currentTarget.checked);
            },
            id: J,
            ref: o,
            type: "checkbox",
            role: "switch",
            inert: W.inert,
            ...O("input")
          }
        ),
        /* @__PURE__ */ d.jsxs(
          $,
          {
            "aria-hidden": "true",
            component: "span",
            mod: { error: P, "label-position": v, "without-labels": !p && !h },
            ...O("track"),
            children: [
              /* @__PURE__ */ d.jsx(
                $,
                {
                  component: "span",
                  mod: { "reduce-motion": !0, "with-thumb-indicator": j && !y },
                  ...O("thumb"),
                  children: y
                }
              ),
              /* @__PURE__ */ d.jsx("span", { ...O("trackLabel"), children: pe ? p : h })
            ]
          }
        )
      ]
    }
  );
});
Oe.classes = { ...mt, ...Yt };
Oe.displayName = "@mantine/core/Switch";
Oe.Group = so;
const [pa, io] = ge(
  "Tabs component was not found in the tree"
);
var Ce = { root: "m_89d60db1", "list--default": "m_576c9d4", list: "m_89d33d6d", tab: "m_4ec4dce6", panel: "m_b0c91715", tabSection: "m_fc420b1f", tabLabel: "m_42bbd1ae", "tab--default": "m_539e827b", "list--outline": "m_6772fbd5", "tab--outline": "m_b59ab47c", "tab--pills": "m_c3381914" };
const lo = z((e, o) => {
  const r = I("TabsList", null, e), { children: t, className: n, grow: a, justify: i, classNames: s, styles: c, style: u, mod: l, ...h } = r, p = io();
  return /* @__PURE__ */ d.jsx(
    $,
    {
      ...h,
      ...p.getStyles("list", {
        className: n,
        style: u,
        classNames: s,
        styles: c,
        props: r,
        variant: p.variant
      }),
      ref: o,
      role: "tablist",
      variant: p.variant,
      mod: [
        {
          grow: a,
          orientation: p.orientation,
          placement: p.orientation === "vertical" && p.placement,
          inverted: p.inverted
        },
        l
      ],
      "aria-orientation": p.orientation,
      __vars: { "--tabs-justify": i },
      children: t
    }
  );
});
lo.classes = Ce;
lo.displayName = "@mantine/core/TabsList";
const co = z((e, o) => {
  const r = I("TabsPanel", null, e), { children: t, className: n, value: a, classNames: i, styles: s, style: c, mod: u, keepMounted: l, ...h } = r, p = io(), g = p.value === a, b = p.keepMounted || l || g ? t : null;
  return /* @__PURE__ */ d.jsx(
    $,
    {
      ...p.getStyles("panel", {
        className: n,
        classNames: i,
        styles: s,
        style: [c, g ? void 0 : { display: "none" }],
        props: r
      }),
      ref: o,
      mod: [{ orientation: p.orientation }, u],
      role: "tabpanel",
      id: p.getPanelId(a),
      "aria-labelledby": p.getTabId(a),
      ...h,
      children: b
    }
  );
});
co.classes = Ce;
co.displayName = "@mantine/core/TabsPanel";
const uo = z((e, o) => {
  const r = I("TabsTab", null, e), {
    className: t,
    children: n,
    rightSection: a,
    leftSection: i,
    value: s,
    onClick: c,
    onKeyDown: u,
    disabled: l,
    color: h,
    style: p,
    classNames: g,
    styles: b,
    vars: f,
    mod: m,
    tabIndex: y,
    ...x
  } = r, w = fe(), { dir: _ } = Qe(), v = io(), C = s === v.value, P = (N) => {
    v.onChange(v.allowTabDeactivation && s === v.value ? null : s), c?.(N);
  }, S = { classNames: g, styles: b, props: r };
  return /* @__PURE__ */ d.jsxs(
    Ue,
    {
      ...v.getStyles("tab", { className: t, style: p, variant: v.variant, ...S }),
      disabled: l,
      unstyled: v.unstyled,
      variant: v.variant,
      mod: [
        {
          active: C,
          disabled: l,
          orientation: v.orientation,
          inverted: v.inverted,
          placement: v.orientation === "vertical" && v.placement
        },
        m
      ],
      ref: o,
      role: "tab",
      id: v.getTabId(s),
      "aria-selected": C,
      tabIndex: y !== void 0 ? y : C || v.value === null ? 0 : -1,
      "aria-controls": v.getPanelId(s),
      onClick: P,
      __vars: { "--tabs-color": h ? ee(h, w) : void 0 },
      onKeyDown: Io({
        siblingSelector: '[role="tab"]',
        parentSelector: '[role="tablist"]',
        activateOnFocus: v.activateTabWithKeyboard,
        loop: v.loop,
        orientation: v.orientation || "horizontal",
        dir: _,
        onKeyDown: u
      }),
      ...x,
      children: [
        i && /* @__PURE__ */ d.jsx("span", { ...v.getStyles("tabSection", S), "data-position": "left", children: i }),
        n && /* @__PURE__ */ d.jsx("span", { ...v.getStyles("tabLabel", S), children: n }),
        a && /* @__PURE__ */ d.jsx("span", { ...v.getStyles("tabSection", S), "data-position": "right", children: a })
      ]
    }
  );
});
uo.classes = Ce;
uo.displayName = "@mantine/core/TabsTab";
const wo = "Tabs.Tab or Tabs.Panel component was rendered with invalid value or without value", ha = {
  keepMounted: !0,
  orientation: "horizontal",
  loop: !0,
  activateTabWithKeyboard: !0,
  variant: "default",
  placement: "left"
}, va = G((e, { radius: o, color: r, autoContrast: t }) => ({
  root: {
    "--tabs-radius": Q(o),
    "--tabs-color": ee(r, e),
    "--tabs-text-color": ze(t, e) ? Ae({ color: r, theme: e, autoContrast: t }) : void 0
  }
})), ke = z((e, o) => {
  const r = I("Tabs", ha, e), {
    defaultValue: t,
    value: n,
    onChange: a,
    orientation: i,
    children: s,
    loop: c,
    id: u,
    activateTabWithKeyboard: l,
    allowTabDeactivation: h,
    variant: p,
    color: g,
    radius: b,
    inverted: f,
    placement: m,
    keepMounted: y,
    classNames: x,
    styles: w,
    unstyled: _,
    className: v,
    style: C,
    vars: P,
    autoContrast: S,
    mod: N,
    attributes: R,
    ...k
  } = r, j = ie(u), [A, U] = te({
    value: n,
    defaultValue: t,
    finalValue: null,
    onChange: a
  }), T = B({
    name: "Tabs",
    props: r,
    classes: Ce,
    className: v,
    style: C,
    classNames: x,
    styles: w,
    unstyled: _,
    attributes: R,
    vars: P,
    varsResolver: va
  });
  return /* @__PURE__ */ d.jsx(
    pa,
    {
      value: {
        placement: m,
        value: A,
        orientation: i,
        id: j,
        loop: c,
        activateTabWithKeyboard: l,
        getTabId: Te(`${j}-tab`, wo),
        getPanelId: Te(`${j}-panel`, wo),
        onChange: U,
        allowTabDeactivation: h,
        variant: p,
        color: g,
        radius: b,
        inverted: f,
        keepMounted: y,
        unstyled: _,
        getStyles: T
      },
      children: /* @__PURE__ */ d.jsx(
        $,
        {
          ref: o,
          id: j,
          variant: p,
          mod: [
            {
              orientation: i,
              inverted: i === "horizontal" && f,
              placement: i === "vertical" && m
            },
            N
          ],
          ...T("root"),
          ...k,
          children: s
        }
      )
    }
  );
});
ke.classes = Ce;
ke.displayName = "@mantine/core/Tabs";
ke.Tab = uo;
ke.Panel = co;
ke.List = lo;
const An = No, ba = "_root_5pdnf_1", fa = {
  root: ba
}, ga = "_root_ix9qz_1", ya = "_labelWrapper_ix9qz_5", xa = "_body_ix9qz_16", _a = "_inner_ix9qz_20", wa = "_label_ix9qz_5", Ca = "_error_ix9qz_25", ka = {
  root: ga,
  labelWrapper: ya,
  body: xa,
  inner: _a,
  label: wa,
  error: Ca
}, Sa = "_content_1xi37_1", $a = "_header_1xi37_6", Pa = "_body_1xi37_7", ja = {
  content: Sa,
  header: $a,
  body: Pa
}, Na = "_legend_1j2iz_1", Ia = {
  legend: Na
}, Ra = "_label_16ex9_1", Ta = "_wrapper_16ex9_9", za = "_required_16ex9_28", Ie = {
  label: Ra,
  wrapper: Ta,
  required: za
}, Aa = "_dropdown_2qmd8_1", Ma = "_item_2qmd8_6", Va = {
  dropdown: Aa,
  item: Ma
}, Ea = "_content_1kxny_1", La = "_header_1kxny_9", Oa = "_title_1kxny_13", Da = "_body_1kxny_20", Fa = {
  content: Ea,
  header: La,
  title: Oa,
  body: Da
}, Wa = "_root_1nihe_1", Ba = "_description_1nihe_25", Ga = "_icon_1nihe_31", Ha = {
  root: Wa,
  description: Ba,
  icon: Ga
}, qa = "_control_p61jl_1", Ka = "_dots_p61jl_23", Ua = {
  control: qa,
  dots: Ka
}, Ja = "_pinInput_keiya_1", Za = "_input_keiya_6", Qa = {
  pinInput: Ja,
  input: Za
}, Xa = "_indicator_pd75v_1", Ya = "_icon_pd75v_10", en = {
  indicator: Xa,
  icon: Ya
}, on = "_dropdown_1si48_1", tn = "_option_1si48_8", rn = {
  dropdown: on,
  option: tn
}, an = "_thead_1uacm_1", nn = "_th_1uacm_1", sn = "_td_1uacm_8", ln = {
  thead: an,
  th: nn,
  td: sn
}, cn = [
  "#e7f0ff",
  "#cedcff",
  "#9bb6ff",
  "#648dff",
  "#386bfe",
  "#1c55fe",
  "#0648FF",
  "#003ce4",
  "#0034cc",
  "#002db4"
], dn = (e) => {
  const o = Wt(e);
  return e.variant === "default" ? {
    background: "#f2f2f2",
    color: "var(--fjord-grey-500)",
    hover: "var(--grey-100)",
    border: "none"
  } : e.variant === "primary" ? {
    background: "var(--noble-blue-500)",
    color: "var(--brand-white)",
    hover: $e("var(--noble-blue-400)", 0.15),
    border: "none"
  } : e.variant === "danger" ? {
    background: "#EF3030",
    border: "none",
    color: "var(--brand-white)",
    hover: $e("#EF3030", 0.1),
    hoverColor: "var(--brand-white)"
  } : e.variant === "secondary" ? {
    background: "transparent",
    color: "var(--fjord-grey-400)",
    border: "1px solid var(--fjord-grey-400)",
    hover: $e("var(--brand-white)", 0.1)
  } : e.variant === "brand-gradient" ? {
    background: "var(--brand-gradient)",
    border: "none",
    color: "var(--brand-white)",
    hover: "transparent"
  } : e.variant === "secondary-alt" ? {
    background: "transparent",
    color: "var(--noble-blue-500)",
    border: "1px solid var(--noble-blue-500)",
    hover: $e("var(--brand-white)", 0.1)
  } : o;
}, un = (e, o) => o.variant === "transparent" || o.size === "xs" ? {
  root: {
    "--ai-size": "1.625rem"
  }
} : o.size === "sm" ? {
  root: {
    "--ai-size": "2.125rem"
  }
} : o.size === "md" ? {
  root: {
    "--ai-size": "2.625rem"
  }
} : o.size === "lg" ? {
  root: {
    "--ai-size": "3.125rem"
  }
} : { root: {} }, mn = (e, o) => o.size === "sm" ? {
  root: {
    "--button-height": "2.125rem",
    "--button-padding-x": "0.625rem",
    "--button-fz": "0.75rem"
  }
} : o.size === "md" ? {
  root: {
    "--button-height": "2.625rem",
    "--button-padding-x": "0.625rem",
    "--button-fz": "0.875rem"
  }
} : o.size === "lg" ? {
  root: {
    "--button-height": "3.125rem",
    "--button-padding-x": "0.625rem",
    "--button-fz": "1rem"
  }
} : { root: {} }, pn = (e, o) => o.size === "sm" ? {
  wrapper: {
    "--input-height": "2rem",
    "--input-fz": "0.875rem"
  }
} : o.size === "md" ? {
  wrapper: {
    "--input-height": "2.5rem",
    "--input-fz": "0.875rem"
  }
} : o.size === "lg" ? {
  wrapper: {
    "--input-height": "3rem",
    "--input-fz": "1rem"
  }
} : { wrapper: {} }, hn = {
  variantColorResolver: dn,
  // fontFamily: `${fontFamily}, sans-serif`,
  primaryColor: "noble-blue",
  colors: {
    "noble-blue": cn
  },
  components: {
    ActionIcon: nr.extend({
      vars: un,
      defaultProps: {
        variant: "default",
        size: "md",
        radius: "md"
      }
    }),
    Anchor: Co.extend({
      classNames: fa
    }),
    Button: ar.extend({
      vars: mn,
      defaultProps: {
        variant: "default",
        size: "md",
        radius: "xl"
      }
    }),
    Checkbox: er.extend({
      classNames: ka
    }),
    Drawer: Tt.extend({
      classNames: ja
    }),
    Fieldset: Rt.extend({
      classNames: Ia
    }),
    FileInput: It.extend({
      defaultProps: {
        radius: "md",
        inputWrapperOrder: ["label", "input", "description", "error"]
      }
    }),
    Input: me.extend({
      vars: pn,
      classNames: () => ({
        wrapper: Ie.wrapper,
        input: Ie.input
      }),
      defaultProps: {
        size: "xl",
        radius: "md"
      }
    }),
    InputWrapper: me.Wrapper.extend({
      classNames: () => ({
        label: Ie.label,
        description: "text-p-s text-fjord-grey-500",
        required: Ie.required,
        error: "text-p-s mt-1"
      })
    }),
    JsonInput: Nt.extend({
      defaultProps: {
        size: "md",
        radius: "md",
        inputWrapperOrder: ["label", "input", "description", "error"]
      }
    }),
    Menu: Xt.extend({
      classNames: Va
    }),
    Modal: jt.extend({
      classNames: Fa
    }),
    Notification: sr.extend({
      classNames: Ha
    }),
    NumberInput: Pt.extend({
      defaultProps: {
        size: "md",
        radius: "md",
        inputWrapperOrder: ["label", "input", "description", "error"]
      }
    }),
    Pagination: Qt.extend({
      classNames: Ua
    }),
    PasswordInput: $t.extend({
      defaultProps: {
        size: "md",
        radius: "md",
        inputWrapperOrder: ["label", "input", "description", "error"]
      },
      classNames: {
        input: "caret-black"
      }
    }),
    PillsInput: St.extend({
      defaultProps: {
        radius: "md"
      }
    }),
    PinInput: kt.extend({
      classNames: Qa,
      defaultProps: {
        size: "md"
      }
    }),
    RadioIndicator: Ee.extend({
      classNames: en
    }),
    Select: Ct.extend({
      classNames: rn,
      styles: {
        dropdown: {
          maxHeight: 240,
          overflow: "auto"
        }
      },
      defaultProps: {
        withScrollArea: !1,
        comboboxProps: {
          radius: "md",
          dropdownPadding: 0
        },
        radius: "md"
      }
    }),
    Switch: Oe.extend({
      defaultProps: {
        size: "md",
        withThumbIndicator: !1
      }
    }),
    Table: Zt.extend({
      classNames: ln
    }),
    TagsInput: wt.extend({
      defaultProps: {
        size: "md",
        radius: "md",
        inputWrapperOrder: ["label", "input", "description", "error"]
      }
    }),
    TextInput: Ut.extend({
      defaultProps: {
        size: "md",
        radius: "md",
        inputWrapperOrder: ["label", "input", "description", "error"]
      }
    }),
    Textarea: _t.extend({
      defaultProps: {
        size: "md",
        radius: "md"
      }
    }),
    Typography: No.extend({
      classNames: {
        root: "[&_p]:mb-[7px]"
      }
    })
  }
}, He = /* @__PURE__ */ new Map(), vn = ({ fontFamily: e }) => {
  if (He.has(e)) return He.get(e);
  const o = zt({
    ...hn,
    fontFamily: `${e}, sans-serif`
  });
  return He.set(e, o), o;
}, bn = ({
  children: e,
  themeConfig: o,
  nonce: r,
  themeOverrides: t = []
}) => {
  const n = Po(() => {
    const a = vn(o);
    return kr(a, ...t);
  }, [o, t]);
  return /* @__PURE__ */ d.jsx(
    Oo,
    {
      theme: n,
      ...r && {
        // Inject nonce if provided to support CSP-compliant inline styles
        getStyleNonce: () => r
      },
      classNamesPrefix: "app",
      children: e
    }
  );
};
bn.displayName = "UIProvider";
export {
  oe as Accordion,
  En as ActionIcon,
  Ln as Anchor,
  Wo as Badge,
  Go as Breadcrumbs,
  On as Button,
  ds as Center,
  Dn as Checkbox,
  to as Chip,
  qo as ChipGroup,
  Jt as Collapse,
  Rn as ColorSchemeScript,
  Fn as Combobox,
  Wn as ConditionalRendering,
  Bn as Container,
  Lr as CopyButton,
  At as DEFAULT_THEME,
  Gn as Drawer,
  Hn as Fieldset,
  qn as FileButton,
  Kn as FileInput,
  me as Input,
  Un as JsonInput,
  lr as Loader,
  Uo as LoadingOverlay,
  Xt as Menu,
  jt as Modal,
  Jn as NumberInput,
  bo as Overlay,
  Qt as Pagination,
  Zn as PasswordInput,
  Qn as Pill,
  St as PillsInput,
  Xn as PinInput,
  hs as Popover,
  _e as Progress,
  we as Radio,
  ms as ScrollArea,
  Yn as Select,
  tt as Skeleton,
  ct as Slider,
  ut as Spoiler,
  Oe as Switch,
  Zt as Table,
  ke as Tabs,
  es as TagsInput,
  os as Text,
  ts as TextInput,
  rs as Textarea,
  ls as Tooltip,
  No as Typography,
  An as TypographyStylesProvider,
  bn as UIProvider,
  Ue as UnstyledButton,
  Tn as mantineHtmlProps,
  ss as mergeMantineTheme,
  kr as mergeThemeOverrides,
  as as useCombobox,
  zn as useDrawersStack
};
